const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGuid = (value) =>
  typeof value === "string" && GUID_REGEX.test(value);

/**
 * Resolves the display label for a read-only select-style field value.
 *
 * Resolution order:
 * 1. Matching option label from the options list (when loaded).
 * 2. A server-resolved label supplied by the caller (e.g. the
 *    employee_range string returned by GET /Providers/{id}).
 * 3. "-" when the raw value is a GUID, so an unresolvable foreign key id
 *    is never shown to the user.
 * 4. The stringified value itself (human-readable values pass through).
 */
export const resolveReadOnlyOptionLabel = ({ options, value, resolvedLabel }) => {
  if (options && Array.isArray(options)) {
    const found = options.find(
      (o) => (o.value || o) === value || o.value === value,
    );
    if (typeof found === "string") return found;
    if (found) return found.label;
  }
  if (resolvedLabel) return resolvedLabel;
  if (isGuid(value)) return "-";
  return String(value);
};
